<template>
  <input
    :class="{ 'dark': dark }"
    type="text"
    :placeholder="placeholder"
    :value="value"
    :style="`background-image: url(${require('@/assets/images/icons/search.png')})`"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'ProaInput',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    value: String
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  background-color: white;
  background-clip: padding-box;
  border: 1px solid $light-border-color;
  border-radius: 4px;
  background-position: 6px center;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  text-indent: 20px;

  &:not(:placeholder-shown) {
    background-image: none !important;
    text-indent: 0px;
  }

  &:focus {
    outline: none;
  }
}

.dark {
  background-color: $light-gray-color;
  border: 1px solid $dark-border-color;
}
</style>
